e
<template>
  <div v-loading="loading" class="content-container">
    <search-comp @onSearch="getList" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-2">
              <div class="das-form-input">
                <div class="label">Mã đặt phòng</div>
                <div class="child-w-80">
                  <input
                    v-model="searchParams.recode"
                    type="text"
                    @keypress="clsAlphaNoOnly"
                  />
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Khách sạn</div>
                <div class="child-w-80">
                  <el-select
                    v-model="searchParams.hotelIdList"
                    collapse-tags
                    multiple
                  >
                    <el-option
                      v-for="(hotel, index) in hotelList"
                      :key="index"
                      :value="hotel.id"
                      :label="hotel.name"
                    />
                  </el-select>
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Tài khoản</div>
                <div class="child-w-80">
                  <!--                       :dropdown-width="400" -->
                  <!-- <select-with-search-table
                    style="width: 100%"
                    :rows="accountOptions"
                    :columns="accountColumns"
                    index-field="id"
                    :dropdown-width="500"
                    :selected-index-field-value="searchParams.account"
                    :value="searchParams.account"
                    @selectionChanged="onSelectRowAccount"
                  >
                    <template v-slot:value="{ selectedValue: selectedData }">
                      {{ selectedData?.name }}
                    </template>
                  </select-with-search-table> -->
                  <el-select
                    v-model="searchParams.account"
                    clearable
                    filterable
                    placeholder="Vui lòng chọn"
                  >
                    <el-option
                      v-for="item in accountOptions"
                      :key="item.id"
                      :label="item.full_name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">Từ ngày</div>
                <div class="child-w-80">
                  <CalendarRange
                    v-model="datetimeRange"
                    style="display: block; width: 500px"
                    mode="date"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
    <div class="content-box daily-trans-report">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title">Báo cáo đặt cọc theo ngày</span>
            </div>
            <div class="button-containers-title">
              <InfoBtn @click="dialogFormVisible = true" />
              <el-dropdown trigger="click" @command="handleCommand">
                <button class="btn medium primary outline download-button">
                  <i class="el-icon-download"></i>
                </button>
                <el-dropdown-menu>
                  <el-dropdown-item command="pdf">Xuất PDF</el-dropdown-item>
                  <el-dropdown-item command="excel"
                    >Xuất Excel</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <button class="btn primary small">Xuất Excel</button> -->
            </div>
            <!-- <button class="btn medium primary outline">Thêm</button> -->
          </div>
          <hr />
          <div v-loading="loading" class="daily-trans__list">
            <el-collapse v-model="collapseNameList">
              <div
                v-for="(dailyTrans, index) in dailyTransDataList"
                :key="index"
                class="daily-trans__item"
              >
                <el-collapse-item :name="index">
                  <template slot="title">
                    <span class="daily-trans__item-header">
                      {{ 'Khách sạn:' }} {{ dailyTrans.hotel_name }}
                    </span>
                  </template>

                  <div class="grid-scroll" style="minH">
                    <!-- :full-width-cell-renderer="fullWidthCellRenderer" -->
                    <GridVx
                      ref="agGrid"
                      :columns="columns"
                      :rows="dailyTrans.rows"
                      :default-col-def="defaultColDef"
                      :is-row-selectable="isRowSelectable"
                      :context="context"
                      class="agGrid daily-trans-synthesis-grid"
                      :auto-size-cell="true"
                    />
                  </div>
                </el-collapse-item>
                <div class="daily-trans__item-footer">
                  {{ 'Tổng' }}: {{ $displayCurrency(dailyTrans.total_money) }}
                </div>
                <!-- <div class="daily-trans__item-footer">Tổng: 220000</div> -->
              </div>
            </el-collapse>
            <div v-if="totalMoney" class="daily-trans__item-footer">
              {{ 'Tổng cộng' }} : {{ $displayCurrency(totalMoney) }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="Chú thích"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>Mã đặt phòng: Hiển thị mã đặt phòng</li>
            <li>Tên phòng: hiển thị số phòng</li>
            <li>Tên khách: Hiển thị tên khách chính đặt phòng</li>
            <li>
              Thời gian tạo: Thời gian tạo giao dịch đặt cọc. format: DDMMYYYY
              HHMMSS
            </li>
            <li>Ngày đến: Ngày đến của đặt phòng</li>
            <li>Ngày đi: Ngày đi của đặt phòng</li>
            <li>Số tiền: Hiển thị số tiền đặt cọc</li>
            <li>
              Hình thức thanh toán : Hình thức thanh toán được chọn thực hiện
              bởi user khi đặc cọc
            </li>
            <li>User: tài khoản thu ngân tạo đặt phòng</li>
            <li>Ghi chú: hiển thị thông tin ghi chú khi đặt cọc</li>
          </ul>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="dialogFormVisible = false">
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */

import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import { getAllHotel } from '@/api/hotel'
import { getReceiveBankAccountApi } from '@/api/booking_service/bookingGroup'
import {
  getDailyDepositApi,
  getUserDepositApi,
  getDailyDepositApiExcel
} from '@/api/report_service/report_b'
import SelectWithSearchTable from '@/components/inputs/SelectWithSearchTable.vue'
import InfoBtn from './components/InfoBtn.vue'
import { downFile } from '@/utils/file-handler'
import { CellRenderTextLink } from '@/utils/cellRenders'
import { getAccount } from '@/api/reception/common'

export default {
  components: {
    CalendarRange,
    SelectWithSearchTable,
    InfoBtn,
    CellRenderTextLink
  },
  data() {
    return {
      collapseNameList: [],
      dailyTransDataList: [],
      totalMoney: null,
      defaultColDef: {
        flex: 1,
        // resizable: true,
        // sortable: true,
        suppressMovable: true,
        wrapText: true,
        autoHeight: true,
        headerComponentParams: {
          template:
            '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            // '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
            // '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
            // '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
            // '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
            '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
            // '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
            '</div>'
        }
      },
      loading: false,
      dialogFormVisible: false,
      hotelList: [],
      accountOptions: [],
      accountColumns: [
        {
          headerName: 'Mã tài khoản',
          headerTooltip: 'Mã tài khoản',
          field: 'code',
          tooltipField: 'code',
          minWidth: 120,
          maxWidth: 140
        },
        {
          headerName: 'Số tài khoản',
          headerTooltip: 'Số tài khoản',
          field: 'acc_num',
          tooltipField: 'acc_num',
          minWidth: 120,
          maxWidth: 150
        },
        {
          headerName: 'Tên ngân hàng',
          headerTooltip: 'Tên ngân hàng',
          field: 'name',
          tooltipField: 'name',
          flex: 1,
          minWidth: 100
        }
      ],
      searchParams: {
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD'),
        recode: null,
        account: null,
        hotelIdList: []
      },
      searchParamsDefault: {
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD'),
        recode: null,
        account: null,
        hotelIdList: []
      },
      columns: [
        // {
        //   field: 'hotelName',
        //   cellClass: 'grid-cell-centered',
        //   maxWidth: 100,
        //   rowGroup: true,
        //   hide: true
        // },
        // {
        //   field: 'total',
        //   cellClass: 'grid-cell-centered',
        //   maxWidth: 100,
        //   sortable: false
        // },
        {
          headerName: 'Recode',
          field: 'group_code',
          tooltipField: 'group_code',
          cellRenderer: 'CellRenderTextLink',
          minWidth: 120,
          maxWidth: 150,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.bookingCode'),
          field: 'recode',
          tooltipField: 'recode',
          minWidth: 120,
          maxWidth: 150,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.roomName'),
          field: 'roomNum',
          minWidth: 100,
          maxWidth: 140,
          tooltipField: 'roomNum',
          sortable: false
        },
        {
          headerName: this.$t('grid.column.customerName'),
          field: 'guestName',
          tooltipField: 'guestName',
          minWidth: 120,

          sortable: false
        },
        {
          headerName: this.$t('grid.column.createDatetime'),
          headerTooltip: this.$t('grid.column.createDatetime'),
          field: 'createDate',
          tooltipField: 'createDate',
          sortable: false,
          minWidth: 170,
          maxWidth: 170
        },
        {
          headerName: 'Ngày cọc',
          headerTooltip: 'Ngày cọc',
          field: 'deposit_date',
          tooltipField: 'deposit_date',
          sortable: false,
          minWidth: 120,
          maxWidth: 120
        },
        {
          headerName: this.$t('grid.column.arrivalDate'),
          field: 'arriveDate',
          tooltipField: 'arriveDate',
          minWidth: 120,
          maxWidth: 120,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.departureDate'),
          field: 'departDate',
          minWidth: 120,
          maxWidth: 120,
          tooltipField: 'departDate',
          sortable: false
        },

        {
          headerName: this.$t('grid.column.amountOfMoney'),
          field: 'amountMoney',
          tooltipField: 'amountMoney',
          valueFormatter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            } else {
              return null
            }
          },
          // aggFunc: 'sum',,
          minWidth: 100
        },
        {
          headerName: this.$t('grid.column.paymethod'),
          headerTooltip: this.$t('grid.column.paymethod'),
          field: 'paymentMethod',
          tooltipField: 'paymentMethod',
          minWidth: 100,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.user'),
          field: 'createUserName',
          tooltipField: 'createUserName',
          sortable: false,
          minWidth: 120
        },
        {
          headerName: this.$t('grid.column.note'),
          field: 'note',
          tooltipField: 'note',
          sortable: false,
          minWidth: 100
        }
      ],
      rows: [],
      pinnedBottomRowData: [
        {
          amountMoney: 0
        }
      ]
    }
  },
  computed: {
    datetimeRange: {
      get() {
        return {
          start: this.searchParams.dateFrom,
          end: this.searchParams.dateTo
        }
      },
      set(val) {
        this.searchParams.dateFrom = val.start
        this.searchParams.dateTo = val.end
      }
    }
  },
  async created() {
    await this.getListHotel()

    this.fnGetReceiveBankAccount()
  },
  beforeMount() {
    this.context = {
      componentParent: this
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    onCellRenderTextLinkClick(data) {
      console.debug(data)
      const tmpRecode = data?.data?.recode
      if (tmpRecode) {
        this.$router.push(`/reservation/search_reservation?recode=${tmpRecode}`)
      }
    },
    clsAlphaNoOnly(e) {
      // Accept only alpha numerics, no special characters
      const regex = new RegExp('^[a-zA-Z0-9 ]+$')
      const str = String.fromCharCode(!e.charCode ? e.which : e.charCode)
      if (regex.test(str)) {
        return true
      }

      e.preventDefault()
      return false
    },
    handleCommand(cmmd) {
      // this.$message('click on item ' + cmmd)
      switch (cmmd) {
        case 'pdf':
          break
        case 'excel':
          this.downloadExcel()
          break
        default:
          this.$message('click on item ' + cmmd)
          break
      }
    },
    headerHeightGetter() {
      var columnHeaderTexts = [
        ...document.querySelectorAll('.ag-header-cell-text')
      ]
      var clientHeights = columnHeaderTexts.map(
        headerText => headerText.clientHeight
      )
      var tallestHeaderTextHeight = Math.max(...clientHeights)

      return tallestHeaderTextHeight
    },
    headerHeightSetter() {
      var padding = 30

      var height = this.headerHeightGetter() / 2 + padding
      this.$refs.agGrid.gridApi.setHeaderHeight(height)
      this.$refs.agGrid.gridApi.resetRowHeights()
    },
    async getListHotel() {
      const data = await getAllHotel()
      this.hotelList = data.data
    },
    onSelectRowAccount(val) {
      this.searchParams.account = val.id
    },

    async fnGetReceiveBankAccount() {
      const res = await getAccount({
        userGroupNames: ['Sale-All', 'Sale-staff'],
        is_active: true
      })
      this.accountOptions = res.data.map(item => item.account) || []
    },
    tranferRowData(data) {
      let tranferedDataList = []
      this.totalMoney = data.totalMoney
      data.res.forEach(data => {
        let tranferedData = {
          hotel_name: data.hotelName,
          rows: [],
          total_money: data.totalTotal
        }
        tranferedData.rows = [...data?.infoList]
        // console.log(data)
        if (tranferedData.rows.length > 0) {
          tranferedDataList.push(tranferedData)
          this.collapseNameList.push(data.hotelName)
        }
      })
      return tranferedDataList
    },
    async getList() {
      this.rows = []
      this.loading = true
      await getDailyDepositApi(this.searchParams)
        .then(res => {
          const data = res.data
          this.dailyTransDataList = this.tranferRowData(data)
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
        .finally(() => {
          this.loading = false
          // this.fnSearchGroupList()
        })
    },
    async downloadExcel() {
      this.loading = true
      await getDailyDepositApiExcel(this.searchParams)
        .then(res => {
          const date = this.$moment().format('DD-MM-YYYY')
          downFile(res, 'bao_cao_dat_coc_theo_ngay_' + date + '.xlsx')
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    onReset() {
      this.searchParams = Object.assign({}, this.searchParamsDefault)
      this.getList()
    }
  }
}
</script>

<style lang="scss">
.daily-trans-report {
  --cell-border-color: rgba(189, 195, 199, 0.5);
  --ag-header-bg: #5f8b76;

  height: 100%;

  .daily-trans__list {
    display: flex;
    flex-direction: column;
    // gap: 20px;
    flex: 1;
    overflow-y: auto;

    .el-collapse {
      border: 0 !important;
    }
  }

  .daily-trans__item {
    .el-collapse-item__header {
      background-color: #357456;
      color: #fff !important;
      border-bottom: 1px solid var(--cell-border-color);
    }

    .el-collapse-item__content {
      padding-bottom: 0;
    }

    &-header {
      font-weight: 600;
      flex: 1;
      font-size: 14px;
      padding: 0 12px;
    }

    &-footer {
      height: 34px;
      line-height: 34px;
      padding: 0 12px;
      background-color: #e7f6e5 !important;
      border-bottom: 1px solid var(--cell-border);
      margin-bottom: 2px;
      font-weight: 500;
      font-size: 14px;
    }

    .grid-scroll {
      // height: 400px;
      // max-height: 400px;
    }

    .daily-trans-synthesis-grid.agGrid {
      .header-row,
      .header-row:hover {
        background-color: var(--ag-header-bg) !important;
        color: white;
        font-weight: bold;
      }

      .ag-header-row-column {
        background-color: var(--ag-header-bg) !important;
      }
    }
  }
}
</style>
